import Footer from "../../Components/Footer";
import Navbar2 from "../../Components/Navbar2";

export default function Games3() {
  return (
    <>
      <Navbar2 Page={""} />

      <div
        style={{ display: "flex", justifyContent: "center", padding: "10px 0" }}
      >
        <iframe
          style={{ maxWidth: "100%" }}
          src="https://wordwall.net/embed/8beadc9ef50d482493a442867e2455f8?themeId=1&templateId=5&fontStackId=0"
          width="500"
          height="380"
          frameborder="0"
          allowfullscreen
        ></iframe>
      </div>

      <Footer />
    </>
  );
}
